const styles = theme => ({
  root: {
    marginLeft: 0,
    marginTop: -3,
  },
  topClick: {
      marginBottom: 0,
      backgroundColor: 'rgba(52, 118, 203, 1.0)',
      width: 'calc(100% )',
      marginLeft: 0,
      height: 25,
      borderTopRightRadius:0,
      borderTopLeftRadius:0,
      boxShadow: 'none',
  },
  rightIcon: {
      marginLeft: theme.spacing.unit,
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/ActionsDrawer/components/CandidateItem/components/FullProfileButton/styles.js